import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import { Box, createStyles } from "@mantine/core";

import { LoginRoute } from "@routes/LoginRoute/LoginRoute";
import { UsersRoute } from "@routes/UsersRoute/UsersRoute";
import { PortalRoute } from "@routes/PortalRoute/PortalRoute";
import { ActionsRoute } from "@routes/ActionsRoute/ActionsRoute";
import { PublicRoute } from "@components/PublicRoute/PublicRoute";
import { RegisterRoute } from "@routes/RegisterRoute/RegisterRoute";
import { SettingsRoute } from "@routes/SettingsRoute/SettingsRoute";
import { AuthProvider } from "@components/AuthProvider/AuthProvider";
import { PrivateRoute } from "@components/PrivateRoute/PrivateRoute";
import { VerifyEmailRoute } from "@routes/VerifyEmailRoute/VerifyEmailRoute";
import { SubmissionsRoute } from "@routes/SubmissionsRoute/SubmissionsRoute";
import { ResetPasswordRoute } from "@routes/ResetPasswordRoute/ResetPasswordRoute";
import { ForgotPasswordRoute } from "@routes/ForgotPasswordRoute/ForgotPasswordRoute";
import { VolunteeringFormRoute } from "@routes/VolunteeringFormRoute/VolunteeringFormRoute";
import { DemoRegistrationFormRoute } from "@routes/DemoRegistrationFormRoute/DemoRegistrationFormRoute";
import { EventRegistrationFormRoute } from "@routes/EventRegistrationFormRoute/EventRegistrationFormRoute";

const useStyles = createStyles((t) => ({
  wrapper: {
    width: "100svw",
    height: "100svh",
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    background: "#F9FAFB",
  },
}));

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/register" />,
  },
  {
    path: "/actions",
    element: <ActionsRoute />,
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <LoginRoute />
      </PublicRoute>
    ),
  },
  {
    path: "/register",
    element: (
      <PublicRoute>
        <RegisterRoute />
      </PublicRoute>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <PublicRoute>
        <ForgotPasswordRoute />
      </PublicRoute>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <PublicRoute>
        <ResetPasswordRoute />
      </PublicRoute>
    ),
  },
  {
    path: "/verify-email",
    element: <VerifyEmailRoute />,
  },
  {
    path: "/portal",
    element: (
      <PrivateRoute>
        <PortalRoute />
      </PrivateRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <PrivateRoute>
        <SettingsRoute />
      </PrivateRoute>
    ),
  },
  {
    path: "/forms/volunteering",
    element: (
      <PrivateRoute>
        <VolunteeringFormRoute />
      </PrivateRoute>
    ),
  },
  {
    path: "/forms/event-registration",
    element: (
      <PrivateRoute>
        <EventRegistrationFormRoute />
      </PrivateRoute>
    ),
  },
  {
    path: "/forms/demo-registration",
    element: (
      <PrivateRoute>
        <DemoRegistrationFormRoute />
      </PrivateRoute>
    ),
  },
  {
    path: "/submissions",
    element: (
      <PrivateRoute>
        <SubmissionsRoute />
      </PrivateRoute>
    ),
  },

  {
    path: "/users",
    element: (
      <PrivateRoute>
        <UsersRoute />
      </PrivateRoute>
    ),
  },
]);

export const App = () => {
  const { classes } = useStyles();
  return (
    <Box
      className={classes.wrapper}
      sx={(t) => ({
        ".mantine-Container-root": {
          maxWidth: 1200,
        },
      })}
    >
      <AuthProvider>
        <RouterProvider router={routes} />
      </AuthProvider>
    </Box>
  );
};
